import { render, staticRenderFns } from "./SlideImage.vue?vue&type=template&id=bd6c6b00&scoped=true&lang=pug&"
import script from "./SlideImage.vue?vue&type=script&lang=js&"
export * from "./SlideImage.vue?vue&type=script&lang=js&"
import style0 from "./SlideImage.vue?vue&type=style&index=0&id=bd6c6b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6c6b00",
  null
  
)

export default component.exports